import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import is from 'is_js';
import AppContext from 'context/Context';
import useAuth from 'hooks/useAuth';
import { getProfileUser } from 'redux/profileUserSlice';
import PortalRoutes from 'routes';
import { CloseButton } from 'components/common/Toast';
import 'react-datepicker/dist/react-datepicker.css';
import 'assets/css/react-datepicker-overrides.css';
import 'react-toastify/dist/ReactToastify.min.css';
import PermissionProvider from './context/PermissionProvider';
import AppErrorBoundary from 'components/layouts/errors/AppErrorBoundary';

import { LicenseManager } from "ag-grid-enterprise";

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE_KEY);

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition }
  } = useContext(AppContext);

  const dispatch = useDispatch();
  const { isAuthenticated } = useAuth();

  // Re-fetch the profile (incl. permissions) on every app load so a change to
  // the user's roles/permissions takes effect on reload — without signing out.
  // This overwrites the permissions snapshot persisted from the last login.
  useEffect(() => {
    if (isAuthenticated) dispatch(getProfileUser());
  }, [dispatch, isAuthenticated]);

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [HTMLClassList, navbarPosition]);


  return (
    <AppErrorBoundary>
      <PermissionProvider>
        <Router basename={process.env.PUBLIC_URL}>
          <PortalRoutes />
          <ToastContainer
            closeButton={CloseButton}
            position={toast.POSITION.BOTTOM_LEFT}
          />
        </Router>
      </PermissionProvider>
    </AppErrorBoundary>
  );
};

export default App;
